import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

//assets
import LeftArrow from "assets/icons/left-arrow.svg";

// components
import { HeaderIcon, HeaderTitle } from "./HeaderComponents";

const Header = ({
  leftTitle,
  centerTitle,
  withBackButton,
  goBackLevel = 1,
  leftIcon,
  rightIcon,
  onClickLeftIcon,
  onClickRightIcon,
  leftComponent,
  centerComponent,
  rightComponent,
  bottomComponent,
  padding,
  backgroundColor,
}) => {
  const navigate = useNavigate();

  const renderLeft = () => {
    if (withBackButton) {
      return (
        <HeaderIcon
          onClick={() => navigate(-goBackLevel)}
          imageSrc={LeftArrow}
        />
      );
    } else if (leftTitle) {
      return <HeaderTitle text={leftTitle} />;
    } else if (leftComponent) {
      return leftComponent();
    } else if (leftIcon) {
      return (
        <HeaderIcon onClick={(e) => onClickLeftIcon(e)} imageSrc={leftIcon} />
      );
    }
  };

  const renderCenter = () => {
    if (centerTitle) {
      return <HeaderTitle text={centerTitle} />;
    } else if (centerComponent) {
      return centerComponent();
    }
  };

  const renderRight = () => {
    if (rightComponent) {
      return rightComponent();
    } else if (rightIcon) {
      return (
        <HeaderIcon onClick={(e) => onClickRightIcon(e)} imageSrc={rightIcon} />
      );
    }
  };

  const renderBottom = () => {
    if (bottomComponent) {
      return bottomComponent();
    }
  };

  const isCenter = centerTitle || centerComponent;
  return (
    <Wrapper>
      <MainWrapper
        padding={padding}
        withBackButton={withBackButton}
        backgroundColor={backgroundColor}
      >
        <LeftWrapper isCenter={isCenter}>{renderLeft()}</LeftWrapper>
        <CenterWrapper isCenter={isCenter}>{renderCenter()}</CenterWrapper>
        <RightWrapper isCenter={isCenter}>{renderRight()}</RightWrapper>
      </MainWrapper>
      <BottomWrapper>{renderBottom()}</BottomWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
  flex: 1;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: ${(props) => (props.withBackButton ? "52px" : "60px")};
  padding: ${(props) => (props.padding ? props.padding : "")};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "transparent"};
`;

const LeftWrapper = styled.div`
  ${(props) => (props.isCenter ? "flex:1" : "")};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const CenterWrapper = styled.div`
  ${(props) => (props.isCenter ? "flex:1" : "")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RightWrapper = styled.div`
  ${(props) => (props.isCenter ? "flex:1" : "")};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const BottomWrapper = styled.div``;

export default Header;
